import { createReducer } from "@reduxjs/toolkit";
import type { RetrievalState } from "@redux/state/shared-types";
import type { AdminTeacherVM } from "@shared-kernel/application/ports/admin/admin-repository";
import { retrieveTeacher } from "./retrieve-teacher";

const initialState: RetrievalState<AdminTeacherVM | null> = { fetching: "idle", data: null };

export const retrieveTeacherReducer = createReducer<RetrievalState<AdminTeacherVM | null>>(initialState, builder => {
  builder.addCase(retrieveTeacher.fulfilled, (state, { payload }) => {
    return {
      ...state,
      data: payload,
      fetching: "success",
    };
  });
  builder.addCase(retrieveTeacher.pending, state => {
    return {
      ...state,
      fetching: "pending",
    };
  });
  builder.addCase(retrieveTeacher.rejected, state => {
    return {
      ...state,
      fetching: "failed",
    };
  });
});
